import React from "react";
import "../styles/judges.css";
import "aos/dist/aos.css";
import { Clock } from "lucide-react";
import ritesh from "./Images/RiteshHon.png";
import gokul from "./Images/gokul.jpeg";
import sagnik from "./Images/sagnik.jpeg";
import om from "./Images/OM.jpeg";
import maruf from "./Images/maruf.jpeg";
import jayesh from "./Images/jayesh.jpeg";
import saif from "./Images/saif.png";
import prathamesh from "./Images/prathamesh.jpeg";
import anirudha from "./Images/aniruda.jpeg";
import sai from "./Images/saiprasad.jpeg";
import pdf from "./Images/Handbook_Geekvishwa.pdf";
import reg from "./Images/regeteams.pdf";
import r2 from "./Images/fin.pdf";
import vj from "./Images/vj.jpeg";
import pm from "./Images/pm.jpeg";
import score from "./Images/finalists.pdf";
import rak from "./Images/rak.jpeg";
import mg from "./Images/mg.jpeg";

const Judges = () => {
  // Sample data for judges
  const round1Judges = [
    {
      name: "Ritesh Hon",
      role: "Founder of Unstag, Skillcrunch, Google DSC lead",
      image: ritesh,
    },
    {
      name: "Gokul B",
      role: "SDE @Shoreline Ai",
      image: gokul,
    },
    {
      name: "Om Dhede",
      role: "Intern @ KPMG",
      image: om,
    },
    { name: "Maruf Khan", role: "SDE intern @ cognida.ai", image: maruf },
    {
      name: "Jayesh Bhave",
      role: "Brand Protection and Monitoring Analyst @CMS IT Services",
      image: jayesh,
    },
    {
      name: "Saif Ustad",
      role: "Associate SDE IDeaS Revenuew Solutions",
      image: saif,
    },
    {
      name: "Prathamesh Mutkure",
      role: "Full Stack Developer UpAndUp.Life",
      image: prathamesh,
    },
    {
      name: "Anirudha Kurhade",
      role: "SDE @ Transunion",
      image: anirudha,
    },
  ];

  const round2Judges = [
    {
      name: "Sagnik Ghosh",
      role: "CEO @ WorqHat",
      image: sagnik,
    },
    {
      name: "Saiprasad Shankar ",
      role: "CTO at Deciml",
      image: sai,
    },
    {
      name: "Parag Mhatre",
      role: "Artificial Intelligence Engineer, Google Cloud",
      image: pm,
    },
    {
      name: "Vijaykumar Jangamashetti",
      role: "Sr Google Cloud Consulting Architect",
      image: vj,
    },
    {
      name: "Rakesh Khatri",
      role: "Enterprise Architect",
      image: rak,
    },
    {
      name: "Manish Godse",
      role: "GenAI | Entreprenuer",
      image: mg,
    },
  ];

  const renderJudges = (judges) =>
    judges.map((judge, index) => (
      <div
        key={index}
        className="bg-custom-gradient p-4 md:p-6 w-52 rounded-lg text-center shadow-lg"
      >
        <img
          src={judge.image}
          alt={judge.name}
          className="w-16 h-16 md:w-24 md:h-24 rounded-full mx-auto object-cover"
        />
        <p className="mt-4 text-lg md:text-xl font-semibold bg-transparent">
          {judge.name}
        </p>
        <p className="text-sm text-gray-300 bg-transparent">{judge.role}</p>
      </div>
    ));

  return (
    <div className="p-8 md:p-16 lg:px-32 bg-black text-white min-h-screen">
      {/* Round 1 Section */}
      <div className="space-y-16" id="target-section">
        <div className="flex flex-col md:flex-row items-center md:items-start space-y-8 md:space-y-0 md:space-x-12">
          {/* Round 1 Content */}
          <div className="text-center md:text-left">
            <h1 className="bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text text-transparent text-4xl md:text-6xl font-bold">
              ROUND
            </h1>
            <p className="bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text text-transparent text-[5rem] md:text-[8rem] lg:text-[10rem] font-extrabold">
              1
            </p>
          </div>

          <div>
            <p className="text-gray-400 text-sm md:text-lg">14 Jan, Tuesday</p>
            <h2 className="text-2xl md:text-4xl font-bold mt-1">
              PPT Submission
            </h2>
            <div className="mt-6 bg-gray-900 p-4 md:p-6 rounded-lg">
              {/* Instructions */}
              <ul className="list-disc list-inside space-y-2 md:space-y-3 text-gray-300 bg-transparent">
                <li>
                  All Teams Must Submit A PPT By{" "}
                  <span className="font-bold bg-gradient-to-r from-blue-700 to-blue-600 bg-clip-text text-transparent">
                    11:59 PM 14th, Tuesday
                  </span>
                </li>
                <li>
                  Judges Will Review Presentations And Shortlist 40 Teams Based
                  On Criteria (Innovation, Business Viability, Understanding).
                </li>
                <li>
                  Notifications Will Be Sent To Shortlisted Teams On 16th
                  January.
                </li>
              </ul>
            </div>
            <div>
              <button
                type="button"
                className="register-btn"
                style={{ padding: "1.25rem 3rem" }}
                onClick={() => {
                  window.open(pdf, "_blank");
                }}
              >
                View Problem Statements
              </button>
            </div>

            {/* Judges Section */}
            <div className="mt-8">
              <h2 className="text-2xl md:text-4xl font-bold mb-6">Judges</h2>
              <div className="flex justify-evenly flex-wrap gap-5">
                {renderJudges(round1Judges)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="mt-16 mb-16" />

      {/* Round 2 Section */}
      <div className="space-y-16" id="target2">
        <div className="flex flex-col md:flex-row items-center md:items-start space-y-8 md:space-y-0 md:space-x-12">
          {/* Round 2 Content */}
          <div className="text-center md:text-left">
            <h1 className="bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text text-transparent text-4xl md:text-6xl font-bold">
              ROUND
            </h1>
            <p className="bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text text-transparent text-[5rem] md:text-[8rem] lg:text-[10rem] font-extrabold">
              2
            </p>
          </div>

          <div>
            <p className="text-gray-400 text-sm md:text-lg">20 Jan, Monday</p>
            <h2 className="text-2xl md:text-4xl font-bold mt-1">
              Prototype Presentation
            </h2>
            <div className="mt-6 bg-gray-900 p-4 md:p-6 rounded-lg">
              {/* Session Details */}
              <h1 className="font-bold text-2xl pb-4">First Session</h1>
              <ul className="list-disc list-inside space-y-2 md:space-y-3 text-gray-300 bg-transparent">
                <li>Present Your Project If You Are In The First Batch.</li>
                <li>
                  Each Team Gets 5 Minutes To Present And 2 Minutes for Q&A.
                </li>
                <div className="h-8 bg-[#343232] rounded flex items-center p-8 space-x-1 font-bold">
                  <Clock size={16} className="text-white" />
                  <p>10:00 AM - 12:30 PM</p>
                </div>
              </ul>
            </div>
            <div>
              <button
                type="button"
                className="register-btn"
                style={{ padding: "1.25rem 3rem" }}
                onClick={() => {
                  window.open(r2, "_blank");
                }}
              >
                View Shortlisted Teams
              </button>
            </div>
            <div>
              <button
                type="button"
                className="register-btn"
                style={{ padding: "1.25rem 3rem" }}
                onClick={() => {
                  window.open(score, "_blank");
                }}
              >
                View Scores
              </button>
            </div>

            {/* Judges Section */}
            <div className="mt-8">
              <h2 className="text-2xl md:text-4xl font-bold mb-6">Judges</h2>
              <div className="flex justify-evenly flex-wrap gap-5">
                {renderJudges(round2Judges)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Judges;
